import { ComponentType } from 'react';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import HealthAndSafetyIcon from '@material-ui/icons/LocalHospital';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import DataUsageIcon from '@material-ui/icons/DataUsage';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AssignmentIcon from '@material-ui/icons/Assignment';
import RouterIcon from '@material-ui/icons/Router';
import TimelineIcon from '@material-ui/icons/Timeline';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';

export type PluginCategory =
  | 'health'
  | 'platform'
  | 'data'
  | 'infrastructure'
  | 'governance'
  | 'operations';

export type PluginDescriptor = {
  id: string;
  title: string;
  tagline: string;
  route: string;
  icon: ComponentType<SvgIconProps>;
  category: PluginCategory;
};

export const pluginCatalog: PluginDescriptor[] = [
  {
    id: 'openhmis',
    title: 'Open HMIS',
    tagline:
      'Anonymised public-health datasets, FHIR APIs, open-source health tools and events.',
    route: '/openhmis',
    icon: HealthAndSafetyIcon,
    category: 'health',
  },
  {
    id: 'dhis2',
    title: 'DHIS2',
    tagline:
      'Provision and orchestrate DHIS2 instances on Proxmox/LXC with shared Nginx and multi-node support.',
    route: '/dhis2',
    icon: CloudQueueIcon,
    category: 'platform',
  },
  {
    id: 'openeverest',
    title: 'OpenEverest',
    tagline:
      'Cloud-native database clusters (PostgreSQL, MySQL, MongoDB) on Kubernetes with backups and monitoring.',
    route: '/openeverest',
    icon: DataUsageIcon,
    category: 'data',
  },
  {
    id: 'airflow',
    title: 'Apache Airflow',
    tagline:
      'DAG monitoring, run history, scheduler health and pool utilisation for data pipelines.',
    route: '/airflow',
    icon: AccountTreeIcon,
    category: 'data',
  },
  {
    id: 'asset-register',
    title: 'IT Asset Register',
    tagline: 'Track, assign and audit IT assets across facilities and teams.',
    route: '/asset-register',
    icon: AssignmentIcon,
    category: 'operations',
  },
  {
    id: 'ipam',
    title: 'IPAM',
    tagline: 'IP address management for the national health network.',
    route: '/ipam',
    icon: RouterIcon,
    category: 'infrastructure',
  },
  {
    id: 'monitoring',
    title: 'Monitoring',
    tagline: 'Live system health and performance signals across the platform.',
    route: '/monitoring',
    icon: TimelineIcon,
    category: 'operations',
  },
  {
    id: 'audit',
    title: 'Digital Audit',
    tagline:
      'WHO-aligned digital-health audit framework with maturity scoring and findings management.',
    route: '/audit',
    icon: VerifiedUserIcon,
    category: 'governance',
  },
  {
    id: 'odoo',
    title: 'Odoo',
    tagline:
      'Odoo instance management with Runbot CI/CD and Proxmox orchestration.',
    route: '/odoo',
    icon: BusinessCenterIcon,
    category: 'platform',
  },
];

export const categoryLabels: Record<PluginCategory, string> = {
  health: 'Health',
  platform: 'Platform',
  data: 'Data',
  infrastructure: 'Infrastructure',
  governance: 'Governance',
  operations: 'Operations',
};
